import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import MessageIcon from "@mui/icons-material/Message";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import {
  DataGrid,
  getGridSingleSelectOperators,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarExportContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridLogicOperator,
  GridColumnMenu,
  useGridApiRef,
} from "@mui/x-data-grid";
import Api from "./Api/Api";
import {
  Button,
  Stack,
  Chip,
  MenuItem,
  Select,
  ThemeProvider,
  createTheme,
  Box,
  Autocomplete,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Popover,
  IconButton,
  Typography,
  Avatar,
  Tooltip,
} from "@mui/material";
import { getUser } from "./utils/Auth";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import debounce from "lodash.debounce";
import FilterListIcon from "@mui/icons-material/FilterList";
import { QueryBuilder } from "react-querybuilder";
import { QueryBuilderMaterial } from "@react-querybuilder/material";
import { formatQuery } from "react-querybuilder";
import {
  ButtonGroup,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Row,
} from "react-bootstrap";
import { Toaster, toast } from "sonner";
import { TbReportAnalytics, TbFileImport } from "react-icons/tb";
import { TfiImport } from "react-icons/tfi";

import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";

import CustomToolbar from "./components/CustomToolbar";
import CustomColumnMenu from "./components/CustomColumnMenu";

import CustomerEditInput from "./components/editors/CustomerEditInput";

import useAutoSave from "./hooks/useAutoSave";

import useImportExport from "./hooks/useImportExport";

import { formatRow } from "./utils/formatRow";

import { getColorFromName } from "./utils/ownerColors";

import { buildColumns } from "./utils/buildColumns";

import OptionDialog from "./components/dialogs/OptionDialog";
import CarrierDialog from "./components/dialogs/CarrierDialog";
import ClaimDialog from "./components/dialogs/ClaimDialog";
import CreditDialog from "./components/dialogs/CreditDialog";
import DuplicateDialog from "./components/dialogs/DuplicateDialog";

import FilterPopover from "./components/filters/FilterPopover";
import DashboardGrid from "./components/grid/DashboardGrid";
import BulkActionBar from "./components/grid/BulkActionBar";
import AddColumnDialog from "./components/dialogs/AddColumnDialog";
import CommentDrawer from "./components/comments/CommentDrawer";
import ColumnPermissionDialog from "./components/dialogs/ColumnPermissionDialog";

export default function App() {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [options, setOptions] = useState({});
  const [selectionModel, setSelectionModel] = useState({
    type: "include",
    ids: new Set(),
  });

  const [search, setSearch] = useState("");
  const [filterModel, setFilterModel] = useState({
    items: [],
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [ownerFilter, setOwnerFilter] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);

  const [optionDialog, setOptionDialog] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState("");
  const [optionRows, setOptionRows] = useState([]);

  const [carrierList, setCarrierList] = useState([]);
  const [claimList, setClaimList] = useState([]);
  const [carrierDialog, setCarrierDialog] = useState(false);
  const [newCarrier, setNewCarrier] = useState("");
  const [claimDialog, setClaimDialog] = useState(false);
  const [newClaim, setNewClaim] = useState("");

  const [profileAnchor, setProfileAnchor] = useState(null);

  const [creditList, setCreditList] = useState([]);
  const [creditDialog, setCreditDialog] = useState(false);
  const [newCredit, setNewCredit] = useState("");

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const [duplicateDialog, setDuplicateDialog] = useState(false);
  const [pendingDuplicateRow, setPendingDuplicateRow] = useState(null);

  const [loading, setLoading] = useState(false);

  const [allowDuplicateOnce, setAllowDuplicateOnce] = useState(false);

  const [importDialog, setImportDialog] = useState(false);
  const [importFile, setImportFile] = useState(null);

  const [columnDialog, setColumnDialog] = useState(false);
  const [columnName, setColumnName] = useState("");
  const [columnType, setColumnType] = useState("text");

  const [listSuggestions, setListSuggestions] = useState([]);

  const [commentOpen, setCommentOpen] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);

  // const [columnRestrictions, setColumnRestrictions] = useState({
  //   customer_name: ["WOA", "5142"],
  //   carrier_name: ["WOA"],
  // });

  const [allUsers, setallUsers] = useState([]);

  const [permissionDialog, setPermissionDialog] = useState(false);

  const [permissionColumn, setPermissionColumn] = useState("");

  const [columnRestrictions, setColumnRestrictions] = useState({});

  const fetchColumnPermissions = async () => {
    try {
      const res = await Api.get("/dashboard/column-permissions");

      setColumnRestrictions(res.data || {});
    } catch (err) {
      console.log(err);
    }
  };

  const userOptions = rows
    .filter((row) => row.owner_id && row.owner_name)
    .reduce((acc, row) => {
      if (!acc.find((u) => u.id === row.owner_id)) {
        acc.push({
          id: row.owner_id,
          name: row.owner_name,
        });
      }
      console.log(acc);

      return acc;
    }, []);

  useEffect(() => {
    fetchColumnPermissions();
  }, []);

  useEffect(() => {
    Api.get("/dashboard/users").then((res) => {
      setallUsers(res.data);
    });
  }, []);

  const openPermissionDialog = (field) => {
    setPermissionColumn(field);
    setPermissionDialog(true);
  };

  const withLoading = async (callback, message = "Processing...") => {
    const id = toast.loading(message);

    try {
      setLoading(true);

      const result = await callback();

      toast.success("Success", { id });

      return result;
    } catch (err) {
      toast.error("Failed", { id });

      throw err;
    } finally {
      setLoading(false);
    }
  };

  const openCommentDrawer = (row) => {
    setSelectedRow(row);
    setCommentOpen(true);
  };

  const apiRef = useGridApiRef();

  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = [1, 6].includes(user?.process);
  const isSuperAdmin = [1, 6].includes(user?.process);
  const navigate = useNavigate();
  const darkTheme = createTheme({
    palette: {
      mode: "light",
    },
  });

  const muiTheme = createTheme();

  const fields = useMemo(() => {
    return columns.map((col) => {
      const isDate = col.type === "date";
      const isNumber = col.type === "number";
      const isSelect = col.type === "singleSelect";

      let operators = [];

      // DATE OPERATORS
      if (isDate) {
        operators = [
          { name: "=", label: "=" },
          { name: "!=", label: "!=" },
          { name: "<", label: "before" },
          { name: ">", label: "after" },
          { name: "isNull", label: "is null" },
          { name: "isNotNull", label: "is not null" },
        ];
      }

      // NUMBER OPERATORS
      else if (isNumber) {
        operators = [
          { name: "=", label: "=" },
          { name: "!=", label: "!=" },
          { name: "<", label: "<" },
          { name: ">", label: ">" },
          { name: "<=", label: "<=" },
          { name: ">=", label: ">=" },
        ];
      }

      // SELECT OPERATORS
      else if (isSelect) {
        operators = [
          { name: "=", label: "is" },
          { name: "!=", label: "is not" },
          { name: "in", label: "in" },
          { name: "notIn", label: "not in" },
        ];
      }

      // TEXT OPERATORS
      else {
        operators = [
          { name: "contains", label: "contains" },
          { name: "beginsWith", label: "begins with" },
          { name: "endsWith", label: "ends with" },
          { name: "=", label: "=" },
          { name: "!=", label: "!=" },
        ];
      }

      return {
        name: col.field,
        label: col.headerName || col.field,

        inputType: isNumber ? "number" : isDate ? "date" : "text",

        valueEditorType: isSelect ? "select" : "text",

        operators,

        values: isSelect
          ? (col.valueOptions || []).map((v) => ({
              name: v,
              label: v,
            }))
          : undefined,
      };
    });
  }, [columns]);

  const [query, setQuery] = useState({
    combinator: "and",
    rules: [],
  });

  // --------------filter---------------

  const openFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeFilter = () => {
    setAnchorEl(null);
  };

  const filterOpen = Boolean(anchorEl);

  const openOptionEditor = async (column) => {
    try {
      setSelectedColumn(column);

      const res = await Api.get(`/dashboard/column-options?column=${column}`);

      setOptionRows(res.data || []);

      setOptionDialog(true);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!query.rules.length) {
      setFilterModel({
        items: [],
        logicOperator: GridLogicOperator.And,
      });

      return;
    }

    const items = query.rules
      .filter((r) => r.field && r.operator)
      .map((rule, index) => {
        const selectedColumn = columns.find((c) => c.field === rule.field);

        const isDateColumn = selectedColumn?.type === "date";
        const isSingleSelect = selectedColumn?.type === "singleSelect";
        const isNumberColumn = selectedColumn?.type === "number";

        let operator = "contains";

        switch (rule.operator) {
          case "=":
            if (isDateColumn) {
              operator = "is";
            } else if (isSingleSelect) {
              operator = "is";
            } else if (isNumberColumn) {
              operator = "=";
            } else {
              operator = "equals";
            }
            break;

          case "!=":
            if (isDateColumn || isSingleSelect) {
              operator = "not";
            } else {
              operator = "!=";
            }
            break;

          case "contains":
            operator = "contains";
            break;

          case "beginsWith":
            operator = "startsWith";
            break;

          case "endsWith":
            operator = "endsWith";
            break;

          case "<":
            operator = isDateColumn ? "before" : "<";
            break;

          case ">":
            operator = isDateColumn ? "after" : ">";
            break;

          case "<=":
            operator = "<=";
            break;

          case ">=":
            operator = ">=";
            break;

          case "isNull":
            operator = "isEmpty";
            break;

          case "isNotNull":
            operator = "isNotEmpty";
            break;

          case "in":
            operator = "isAnyOf";
            break;

          default:
            operator = "contains";
        }

        return {
          id: index + 1,
          field: rule.field,
          operator,
          value:
            operator === "isEmpty" || operator === "isNotEmpty"
              ? undefined
              : rule.value,
        };
      });

    console.log("FILTER ITEMS:", items);

    setFilterModel({
      items,

      logicOperator:
        query.combinator === "or"
          ? GridLogicOperator.Or
          : GridLogicOperator.And,
    });
  }, [query, columns]);

  // --------------filter---------------

  const ownerList = [...new Set(rows.map((r) => r.owner_id).filter(Boolean))];

  console.log(customerOptions);
  const Newoptions = ["The Godfather", "Pulp Fiction"];

  const fetchData = async () => {
    return withLoading(async () => {
      const res = await Api.get(
        `/dashboard?search=${search}&sort_field=${sortField}&sort_order=${sortOrder}`,
      );

      const rows = res.data.rows || [];
      const cols = res.data.columns || [];
      const opts = res.data.options || {};

      setOptions(opts);

      const formattedRows = rows.map(formatRow);
      const uniqueRows = Array.from(
        new Map(formattedRows.map((r) => [r.id, r])).values(),
      );
      setRows(uniqueRows);

      // -----------------------------
      // BASE COLUMNS
      // -----------------------------

      const formattedCols = buildColumns({
        cols,
        opts,
        ownerList,
        carrierList,
        claimList,
        creditList,
        listSuggestions,
        openImportDialog: () => setImportDialog(true),
        selectionModel,
        setColumnDialog,
        setRows,
        apiRef,
        openCommentDrawer,
        columnRestrictions,
        openPermissionDialog,
      });

      // -----------------------------
      // FILTER FOR SELECT (IMPORTANT)
      // -----------------------------
      const selectableColumns = cols.filter(
        (c) => c !== "days_with_carrier" && c !== "last_update",
      );

      // -----------------------------
      // FORMULA COLUMN
      // -----------------------------
      console.log("formattedCols", formattedCols);
      const updatedCols = formattedCols.filter(Boolean).map((col) => {
        if (
          col?.field === "days_active" ||
          col?.field === "days_with_carrier"
        ) {
          return {
            ...col,
            editable: false,
            renderCell: (params) =>
              col.field === "days_active"
                ? (params.value ?? 0)
                : params.value || "0 days",
            renderEditCell: () => null,
          };
        }

        return col;
      });

      if (isSuperAdmin) {
        const addColumnButton = {
          field: "add_column",
          headerName: "",
          sortable: false,
          filterable: false,
          editable: false,
          disableColumnMenu: true,
          width: 70,
          minWidth: 70,
          maxWidth: 70,
          align: "center",
          headerAlign: "center",

          renderHeader: () => (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setColumnDialog(true);
              }}
            >
              <AddIcon sx={{ color: "#ffffff" }} />
            </IconButton>
          ),

          renderCell: () => null,
        };

        updatedCols.push(addColumnButton);
      }

      setColumns(updatedCols);
    }, "Loading records...");
  };

  useEffect(() => {
    fetchData();
  }, [search, sortField, sortOrder, carrierList, claimList, creditList]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, []);

  const fetchListSuggestions = async () => {
    try {
      const res = await Api.get("/dashboard/column-suggestions");

      const grouped = res.data.reduce((acc, item) => {
        if (!acc[item.type]) acc[item.type] = [];
        acc[item.type].push(item.carrier_name);
        return acc;
      }, {});

      setListSuggestions(grouped);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchListSuggestions();
  }, []);

  const { handleExport, handleImport, downloadSampleExcel } = useImportExport({
    rows,
    columns,
    fetchData,
    withLoading,
  });

  // -----------------------------
  // ADD ROW
  // -----------------------------
  const handleAddRow = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    setRows((prev) => [
      formatRow({
        id: `temp-${Date.now()}`,
        isNew: true,
        owner_id: user?.username,
        owner_name: user?.full_name,
        creation_log: new Date(), // optional
      }),
      ...prev,
    ]);
  };

  // -----------------------------
  // EDIT (DEBOUNCED)
  // -----------------------------

  const autoSaveRow = useMemo(
    () =>
      debounce(async (cleanRow) => {
        try {
          await Api.post("/dashboard/update", {
            id: cleanRow.id,
            data: cleanRow,
          });

          console.log("✅ Auto saved");
        } catch (err) {
          console.error("AUTO SAVE ERROR:", err);
        }
      }, 3000), // 3 seconds
    [],
  );

  const handleEdit = async (newRow, oldRow) => {
    try {
      if (!newRow?.id) return newRow;

      // =========================
      // SAFE FIELD CLEANER
      // =========================
      const cleanRow = { ...newRow };

      // ❌ ALWAYS REMOVE SYSTEM / NON-DB FIELDS
      const removeFields = [
        "isNew",
        "owner_name",
        "days_active",
        "days_with_carrier",
        "created_at",
        "updated_at",
        "creation_log",
        "allocated_against_invoice",
        "last_update",
      ];

      removeFields.forEach((field) => {
        delete cleanRow[field];
      });

      Object.keys(cleanRow).forEach((key) => {
        if (dayjs.isDayjs(cleanRow[key])) {
          cleanRow[key] = cleanRow[key].format("YYYY-MM-DD");
        }
      });

      // =========================
      // FIX TEMP ID ISSUE
      // =========================
      const isTemp = String(newRow.id).startsWith("temp-");

      cleanRow.id = isTemp ? undefined : String(newRow.id).replace("temp-", "");

      const connoteChanged = newRow.connote_no !== oldRow.connote_no;

      if (connoteChanged && !allowDuplicateOnce) {
        const duplicate = rows.find(
          (r) =>
            r.connote_no === newRow.connote_no &&
            String(r.id) !== String(newRow.id),
        );

        if (duplicate) {
          setPendingDuplicateRow(newRow);
          setDuplicateDialog(true);

          toast.warning("Duplicate Connote Found");

          return oldRow;
        }
      }

      // =========================
      // 1. INSERT FLOW
      // =========================
      if (newRow.isNew || isTemp) {
        const res = await Api.post("/dashboard/insert", {
          data: {
            ...cleanRow,
            customer_name: newRow.customer_name || null,
            franchise_name: newRow.franchise_name || null,
            owner_id: user?.username,
            creation_log: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          },
        });

        const insertedRow = res.data.row;

        setRows((prev) =>
          prev.map((r) =>
            String(r.id) === String(newRow.id) ? formatRow(insertedRow) : r,
          ),
        );

        return insertedRow;
      }

      // =========================
      // 3. UPDATE FLOW
      // =========================
      cleanRow.last_update = dayjs().format("YYYY-MM-DD HH:mm:ss");

      // ✅ instant UI update
      setRows((prev) =>
        prev.map((r) =>
          String(r.id) === String(newRow.id)
            ? { ...r, ...newRow, saving: true }
            : r,
        ),
      );

      // ✅ delayed API save
      autoSaveRow(cleanRow);

      return {
        ...oldRow,
        ...newRow,
        saving: true,
      };
    } catch (err) {
      console.error("UPDATE ERROR:", err.response?.data || err);
      throw err;
    }
  };
  // -----------------------------
  // DELETE
  // -----------------------------
  const selectedCount = selectionModel.ids.size;

  const handleDelete = async () => {
    return withLoading(async () => {
      try {
        const ids = Array.from(selectionModel.ids)
          .map((id) => String(id).replace("temp-", ""))
          .filter(Boolean);

        console.log("Deleting IDs:", ids);

        if (!ids.length) {
          toast.warning("Select valid rows");
          return;
        }

        const res = await Api.post("/dashboard/delete", { ids });

        console.log("DELETE RESPONSE:", res.data);

        if (!res.data.status) {
          throw new Error("Delete failed");
        }

        // 🔥 THIS IS THE FIX
        setRows((prev) => prev.filter((row) => !ids.includes(String(row.id))));

        // clear selection
        setSelectionModel({
          type: "include",
          ids: new Set(),
        });
      } catch (err) {
        console.error("DELETE ERROR:", err);
        toast.error("Delete failed");
      }
    }, "Deleting records...");
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        return withLoading(async () => {
          setSearch(value); // triggers fetchData
        }, "Searching records...");
      }, 500),
    [],
  );

  const filteredRows = useMemo(() => {
    let filtered = [...rows];

    // OWNER FILTER
    if (ownerFilter.length > 0) {
      filtered = filtered.filter((r) => ownerFilter.includes(r.owner_id));
    }

    // QUERY BUILDER FILTERS
    if (query.rules.length > 0) {
      filtered = filtered.filter((row) => {
        const results = query.rules.map((rule) => {
          if (!rule.field || !rule.operator) return true;

          const value = row[rule.field];
          const ruleValue = rule.value;

          switch (rule.operator) {
            case "=":
              return String(value) === String(ruleValue);

            case "!=":
              return String(value) !== String(ruleValue);

            case "contains":
              return String(value || "")
                .toLowerCase()
                .includes(String(ruleValue).toLowerCase());

            case "beginsWith":
              return String(value || "")
                .toLowerCase()
                .startsWith(String(ruleValue).toLowerCase());

            case "endsWith":
              return String(value || "")
                .toLowerCase()
                .endsWith(String(ruleValue).toLowerCase());

            case ">":
              return value > ruleValue;

            case "<":
              return value < ruleValue;

            case ">=":
              return value >= ruleValue;

            case "<=":
              return value <= ruleValue;

            case "in":
              return Array.isArray(ruleValue)
                ? ruleValue.includes(value)
                : false;

            default:
              return true;
          }
        });

        return query.combinator === "and"
          ? results.every(Boolean)
          : results.some(Boolean);
      });
    }

    return filtered;
  }, [rows, query, ownerFilter]);

  const fetchCarriers = async () => {
    try {
      const res = await Api.get("/dashboard/carrier-list");

      setCarrierList(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCarriers();
  }, []);

  const fetchClaims = async () => {
    try {
      const res = await Api.get("/dashboard/claim-list"); // correct route
      setClaimList(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchClaims();
  }, []);

  const fetchCredits = async () => {
    try {
      const res = await Api.get("/dashboard/credit-list", {
        params: {
          t: Date.now(), // prevents cache
        },
      });

      setCreditList(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCredits();
  }, []);

  const openProfileMenu = (event) => {
    setProfileAnchor(event.currentTarget);
  };

  const closeProfileMenu = () => {
    setProfileAnchor(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/");
  };

  // -----------------------------
  // UI
  // -----------------------------
  return (
    <>
      <Toaster richColors position="top-center" />

      <OptionDialog
        optionDialog={optionDialog}
        setOptionDialog={setOptionDialog}
        selectedColumn={selectedColumn}
        optionRows={optionRows}
        setOptionRows={setOptionRows}
        fetchData={fetchData}
      />

      <CarrierDialog
        carrierDialog={carrierDialog}
        setCarrierDialog={setCarrierDialog}
        newCarrier={newCarrier}
        setNewCarrier={setNewCarrier}
        fetchCarriers={fetchCarriers}
      />

      <ClaimDialog
        claimDialog={claimDialog}
        setClaimDialog={setClaimDialog}
        newClaim={newClaim}
        setNewClaim={setNewClaim}
        fetchClaims={fetchClaims}
      />

      <CreditDialog
        creditDialog={creditDialog}
        setCreditDialog={setCreditDialog}
        newCredit={newCredit}
        setNewCredit={setNewCredit}
        fetchCredits={fetchCredits}
      />

      <DuplicateDialog
        duplicateDialog={duplicateDialog}
        setDuplicateDialog={setDuplicateDialog}
        pendingDuplicateRow={pendingDuplicateRow}
        setAllowDuplicateOnce={setAllowDuplicateOnce}
        fetchData={fetchData}
        withLoading={withLoading}
      />
      <AddColumnDialog
        open={columnDialog}
        onClose={() => setColumnDialog(false)}
        columnName={columnName}
        setColumnName={setColumnName}
        columnType={columnType}
        setColumnType={setColumnType}
        fetchData={fetchData}
      />
      <ColumnPermissionDialog
        open={permissionDialog}
        onClose={() => setPermissionDialog(false)}
        column={permissionColumn}
        users={allUsers}
        columnRestrictions={columnRestrictions}
        setColumnRestrictions={setColumnRestrictions}
      />
      <ThemeProvider theme={darkTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ display: "flex", height: "100vh" }}>
            <Sidebar sidebarOpen={sidebarOpen} />

            <Box
              sx={{
                flex: 1,
                width: 0,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                height: "100vh",
              }}
            >
              <Topbar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                user={user}
                profileAnchor={profileAnchor}
                openProfileMenu={openProfileMenu}
                closeProfileMenu={closeProfileMenu}
                handleLogout={handleLogout}
                getColorFromName={getColorFromName}
              />

              <FilterPopover
                filterOpen={filterOpen}
                anchorEl={anchorEl}
                closeFilter={closeFilter}
                fields={fields}
                query={query}
                setQuery={setQuery}
              />

              <Box
                sx={{
                  flex: 1,
                  minHeight: 0,
                  width: "100%",
                  overflow: "hidden",
                  paddingLeft: 2,
                  paddingRight: 2,
                  paddingTop: 2,
                  display: "flex",
                }}
              >
                <DashboardGrid
                  rows={filteredRows}
                  columns={columns}
                  apiRef={apiRef}
                  selectionModel={selectionModel}
                  setSelectionModel={setSelectionModel}
                  handleEdit={handleEdit}
                  handleAddRow={handleAddRow}
                  handleExport={handleExport}
                  ownerFilter={ownerFilter}
                  setOwnerFilter={setOwnerFilter}
                  ownerList={ownerList}
                  rowsData={rows}
                  openFilter={openFilter}
                  handleImport={handleImport}
                  downloadSampleExcel={downloadSampleExcel}
                  openOptionEditor={openOptionEditor}
                  setCarrierDialog={setCarrierDialog}
                  setCreditDialog={setCreditDialog}
                  debouncedSearch={debouncedSearch}
                  handleDelete={handleDelete}
                  user={user}
                  isAdmin={isAdmin}
                  isSuperAdmin={isSuperAdmin}
                  setClaimDialog={setClaimDialog}
                  setFilterModel={setFilterModel}
                  setSortField={setSortField}
                  setSortOrder={setSortOrder}
                  columnRestrictions={columnRestrictions}
                  setColumnRestrictions={setColumnRestrictions}
                  openPermissionDialog={openPermissionDialog}
                />
              </Box>
            </Box>
          </Box>

          <BulkActionBar
            selectedCount={selectedCount}
            handleDelete={handleDelete}
            selectionModel={selectionModel}
            rows={rows}
            columns={columns}
          />
          <CommentDrawer
            open={commentOpen}
            onClose={() => setCommentOpen(false)}
            connoteNo={selectedRow?.connote_no}
            row={selectedRow}
          />
        </LocalizationProvider>
      </ThemeProvider>
    </>
  );
}
